<div class="session bg-primary">
  <div class="session-content">
    <div class="flex-box">
      <mat-card class="flex-card">
        <mat-card-content>
          <form [formGroup]="registerForm" (ngSubmit)="register()">
            <div class="text-xs-center pb-1">
              <img src="assets/images/logo.png" alt="Smart contact" title="Smart contact" width="150" />
              <p class="mat-text-muted">{{ 'register.form.title' | translate }}</p>
            </div>
            <div fxLayout="column" fxLayoutAlign="space-around">
              <div class="pb-1">
                <input matInput placeholder="{{ 'register.form.last_name' | translate }}" formControlName="lastName">
                <small *ngIf="registerForm.controls['lastName'].hasError('required') && registerForm.controls['lastName'].touched"
                  class="mat-text-warn">{{ 'register.validator.lastName_invalid' | translate }}</small>
              </div>
              <div class="pb-1">
                <input matInput placeholder="{{ 'register.form.first_name' | translate }}" formControlName="firstName">
                <small *ngIf="registerForm.controls['firstName'].hasError('required') && registerForm.controls['firstName'].touched"
                  class="mat-text-warn">{{ 'register.validator.firstName_invalid' | translate }}</small>
              </div>
              <div class="pb-1">
                <input matInput placeholder="{{ 'register.form.company' | translate }}" formControlName="company">
                <small *ngIf="registerForm.controls['company'].hasError('required') && registerForm.controls['company'].touched"
                  class="mat-text-warn">{{ 'register.validator.company_invalid' | translate }}</small>
              </div>
              <div class="pb-1">
                <input matInput placeholder="{{ 'register.form.domain' | translate }}" formControlName="domain">
                <p align="end" class="domain-full">{{ registerForm.get('domain').value }}.sip.wephone.io</p>
                <small *ngIf="registerForm.controls['domain'].hasError('required') && registerForm.controls['domain'].touched"
                  class="mat-text-warn">{{ 'register.validator.domain_invalid' | translate }}</small>
              </div>
              <div class="pb-1">
                <mat-select placeholder="{{'register.form.country' | translate }}" formControlName="country" class="mat-select">
                  <mat-option value='fr'>{{ 'country_codes.fr' | translate }}</mat-option>
                  <mat-option value='de'>{{ 'country_codes.de' | translate }}</mat-option>
                  <mat-option value='it'>{{ 'country_codes.it' | translate }}</mat-option>
                  <mat-option value='es'>{{ 'country_codes.es' | translate }}</mat-option>
                  <mat-option value='gb'>{{ 'country_codes.gb' | translate }}</mat-option>
                  <mat-option value='us'>{{ 'country_codes.us' | translate }}</mat-option>
                  <mat-option value='vn'>{{ 'country_codes.vn' | translate }}</mat-option>
                </mat-select>
                <small *ngIf="registerForm.controls['country'].hasError('required') && registerForm.controls['country'].touched"
                  class="mat-text-warn">{{ 'register.validator.country_invalid' | translate }}</small>
              </div>
              <div class="pb-1">

                <input matInput placeholder="{{ 'register.form.email' | translate }}" type="email" formControlName="email">

                <small *ngIf="registerForm.controls['email'].hasError('required') && registerForm.controls['email'].touched"
                  class="mat-text-warn">{{ 'register.validator.email_invalid' | translate }}</small>
                <small *ngIf="registerForm.controls['email'].hasError('email') && registerForm.controls['email'].touched"
                  class="mat-text-warn">{{ 'user.import.email_incorrect' | translate:{ email:
                  registerForm.get('email').value } }}</small>
              </div>
              <div class="pb-1">

                <input matInput placeholder="{{ 'register.form.password' | translate }}" type="password"
                  formControlName="password">

                <small *ngIf="registerForm.controls['password'].hasError('required') && registerForm.controls['password'].touched"
                  class="mat-text-warn">{{ 'register.validator.password_invalid' | translate }}</small>
              </div>
              <button mat-raised-button color="primary" class="login-button gradient-background" type="submit" [disabled]="!registerForm.valid">{{
                'register.form.title' | translate }}</button>
            </div>
            <div class="pt-1 pb-1 text-xs-center">
              <a [routerLink]="['/s/forgot']" class="link-signin mat-text-primary">Forgot password?</a>&nbsp;&nbsp;&nbsp;&nbsp;
              <a [routerLink]="['/s/signin']">Access your account.</a>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
